"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * Asserts that a given value is of type `never`, which is the type left after all other cases have been removed, see
 * https://www.typescriptlang.org/docs/handbook/advanced-types.html.
 * @param x - The value that should never occur.
 */
function assertNever(x) {
    throw new Error('Unexpected object: ' + x);
}
exports.assertNever = assertNever;
/**
 * Number of sides of a rectangle.
 */
exports.NumberOfSides = 4;
/**
 * Checks if a given side is horizontal, i.e., left or right.
 * @param side - The side to check.
 */
function isHorizontalSide(side) {
    return side === 'Left' || side === 'Right';
}
exports.isHorizontalSide = isHorizontalSide;
/**
 * Checks if a given side is vertical, i.e., top or bottom.
 * @param side - The side to check.
 */
function isVerticalSide(side) {
    return !isHorizontalSide(side);
}
exports.isVerticalSide = isVerticalSide;
/**
 * Returns the side next to a given side in the clockwise direction.
 * @param side - The previous side.
 */
function getNextSideClockwise(side) {
    switch (side) {
        case 'Top': return 'Right';
        case 'Right': return 'Bottom';
        case 'Bottom': return 'Left';
        case 'Left': return 'Top';
        default: return assertNever(side);
    }
}
exports.getNextSideClockwise = getNextSideClockwise;
/**
 * Returns the side next to a given side in the counter-clockwise direction.
 * @param side - The previous side.
 */
function getNextSideCounterClockwise(side) {
    switch (side) {
        case 'Top': return 'Left';
        case 'Left': return 'Bottom';
        case 'Bottom': return 'Right';
        case 'Right': return 'Top';
        default: return assertNever(side);
    }
}
exports.getNextSideCounterClockwise = getNextSideCounterClockwise;
/**
 * Interval of real numbers.
 */
var Interval = /** @class */ (function () {
    /**
     * Constructs a new interval.
     * @param min - Greatest lower bound of interval.
     * @param max - Least upper bound of interval.
     */
    function Interval(min, max) {
        this.min = min;
        this.max = max;
        if (max < min) {
            throw new Error('max less than min');
        }
    }
    Interval.prototype.equals = function (i) {
        return this.containsInterval(i) && i.containsInterval(this);
    };
    return Interval;
}());
exports.Interval = Interval;
/**
 * Closed interval of real numbers.
 */
var ClosedInterval = /** @class */ (function (_super) {
    tslib_1.__extends(ClosedInterval, _super);
    function ClosedInterval() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClosedInterval.prototype.containsNumber = function (n) {
        return this.min <= n && n <= this.max;
    };
    ClosedInterval.prototype.containsInterval = function (i) {
        return this.min <= i.min && i.max <= this.max;
    };
    return ClosedInterval;
}(Interval));
exports.ClosedInterval = ClosedInterval;
/**
 * Open interval of real numbers.
 */
var OpenInterval = /** @class */ (function (_super) {
    tslib_1.__extends(OpenInterval, _super);
    function OpenInterval() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OpenInterval.prototype.containsNumber = function (n) {
        return this.min < n && n < this.max;
    };
    OpenInterval.prototype.containsInterval = function (i) {
        var p = i.containsNumber(i.min) ? this.min < i.min : this.min <= i.min;
        var q = i.containsNumber(i.max) ? i.max < this.max : i.max <= this.max;
        return p && q;
    };
    return OpenInterval;
}(Interval));
exports.OpenInterval = OpenInterval;
/**
 * Rectangle in the plane.
 */
var Rectangle = /** @class */ (function () {
    function Rectangle() {
    }
    Rectangle.prototype.containsPoint = function (x, y) {
        return this.xInterval.containsNumber(x) && this.yInterval.containsNumber(y);
    };
    Rectangle.prototype.containsRectangle = function (r) {
        return this.xInterval.containsInterval(r.xInterval) && this.yInterval.containsInterval(r.yInterval);
    };
    Rectangle.prototype.equals = function (r) {
        return this.containsRectangle(r) && r.containsRectangle(this);
    };
    return Rectangle;
}());
exports.Rectangle = Rectangle;
/**
 * Closed rectangle in the plane.
 */
var ClosedRectangle = /** @class */ (function (_super) {
    tslib_1.__extends(ClosedRectangle, _super);
    function ClosedRectangle(minX, maxX, minY, maxY) {
        var _this = _super.call(this) || this;
        _this.xInterval = new ClosedInterval(minX, maxX);
        _this.yInterval = new ClosedInterval(minY, maxY);
        return _this;
    }
    return ClosedRectangle;
}(Rectangle));
exports.ClosedRectangle = ClosedRectangle;
/**
 * Checks if a given outer rectangle contains a given inner rectangle.
 * @param clientRect1 - The outer rectangle.
 * @param clientRect2 - The inner rectangle.
 */
function containsClientRect(clientRect1, clientRect2) {
    var rect1 = clientRectToClosedRectangle(clientRect1);
    var rect2 = clientRectToClosedRectangle(clientRect2);
    return rect1.containsRectangle(rect2);
}
exports.containsClientRect = containsClientRect;
function clientRectToClosedRectangle(_a) {
    var left = _a.left, right = _a.right, top = _a.top, bottom = _a.bottom;
    return new ClosedRectangle(left, right, top, bottom);
}
//# sourceMappingURL=ChromeTooltipUtility.js.map